"use client";

import React, { JSX, useRef } from "react";
import { useParallax } from "@/hooks/useParallax";
import styles from "./CaseStudyHero.module.scss";
import Link from "next/link";

interface CaseStudyHeroProps {
	category?: string | JSX.Element;
	title: string;
	subtitle?: string;
	showLink?: boolean;
	link?: string;
}

const CaseStudyHero: React.FC<CaseStudyHeroProps> = ({ category, title, subtitle, showLink, link }) => {
	const titleRef = useRef<HTMLHeadingElement>(null);
	const subtitleRef = useRef<HTMLParagraphElement>(null);

	// Apply parallax to title
	useParallax(titleRef, {
		speed: 1.1,
		direction: "up",
		distance: 40,
		scrub: 1.5,
	});

	// Apply slightly faster parallax to subtitle for layering effect
	useParallax(subtitleRef, {
		speed: 1.15,
		direction: "up",
		distance: 45,
		scrub: 1.5,
	});

	return (
		<section className={styles["case-study-hero"]}>
			{category && (
				<p className={styles["case-study-hero__category"]}>{category}</p>
			)}
			<div className={styles["case-study-hero__content"]}>
				<h1 ref={titleRef} className={styles["case-study-hero__title"]}>
					{title}
				</h1>
				{subtitle && (
					<p ref={subtitleRef} className={styles["case-study-hero__subtitle"]}>
						{subtitle}
					</p>
				)}
				{
					showLink && link && (
						<Link href={link} className={styles["case-study-hero__link"]} target="_blank" rel="noopener noreferrer">
							<svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect width="18.2315" height="17" rx="8" fill="#FF0000" fillOpacity="0.26" style={{ fill: "#FF0000", fillOpacity: 0.26 }} />
								<path d="M9.59304 13.1383L8.69815 12.2534L11.8054 9.14613H4V7.85352H11.8054L8.69815 4.75124L9.59304 3.86133L14.2315 8.49982L9.59304 13.1383Z" fill="#1E1E1E" style={{ fill: "#1E1E1E", fillOpacity: 1 }} />
							</svg>
							Live Site
						</Link>
					)
				}
			</div>
		</section>
	);
};

export default CaseStudyHero;
